import React from 'react';
import classNames from "classnames";
import { enums } from '../hooks/awyes/useSearchProductPage';

import '../scss/SearchSort.scss';

const options = {
  'Newest In': { searchBy: enums.searchBy.PROMOTED_UPDATED_DATE_ID, orderBy: enums.orderBy.DESCENDING },
  'Price Low to High': { searchBy: enums.searchBy.PRICE_ID, orderBy: enums.orderBy.ASCENDING },
  'Price High to Low': { searchBy: enums.searchBy.PRICE_ID, orderBy: enums.orderBy.DESCENDING },
};

const SearchSort = ({ sort, setSort }) => {
  return (
    <div className="search-sort">
      <span className="search-sort__label">Sort by:</span>
      <select className="search-sort__values" value={sort} onChange={(e) => setSort({ sort: e.target.value, ...options[e.target.value] })}>
        {Object.keys(options).map((key, index) => <option key={key} className={classNames('search-sort__value', {
          'search-sort__value--selected': sort ? key === sort : index === 0,
        })} value={key}>{key}</option>)}
      </select>
    </div>
  );
};

export default SearchSort;